<form
  [formGroup]="forgetPassword"
  class="pia-authenticationBlock-login"
  (ngSubmit)="ngOnSubmit()"
>
  <fieldset>
    <div
      class="form-group"
      [class.is-not-empty]="f.email.value.length > 0"
      [class.is-invalid]="f.email.value.length > 0 && f.email.hasError('email')"
    >
      <legend>{{ "authentication.account_recovery" | translate }}</legend>
      @if (msgFromBack) {
      <p class="msg">
        {{
          "authentication.errors.account_recovery.email." + msgFromBack
            | translate
        }}
      </p>
      }
      <input
        type="text"
        placeholder="{{ 'authentication.email_placeholder' | translate }}"
        id="pia-account-email"
        formControlName="email"
        email
      />
      @if (f.email.hasError('email')) {
      <label for="pia-account-email">
        {{ "authentication.wrong_email" | translate }}
      </label>
      } @else {
      <label for="pia-account-email">
        {{ "authentication.email" | translate }}
      </label>
      }
    </div>
    <div class="validForm">
      <button (click)="onCanceled()">
        {{ "authentication.cancel" | translate }}
      </button>
      <button
        [disabled]="forgetPassword.invalid || loading"
        type="submit"
        class="btn btn-green"
      >
        @if (loading) { ... } @else {
        {{ "authentication.continue" | translate }}
        }
      </button>
    </div>
  </fieldset>
</form>
